import { Component } from "@angular/core";

@Component({
  selector: "app-dashboard-retailer",
  templateUrl: "./dashboard-retailer.component.html",
  styleUrls: ["./dashboard-retailer.component.less"],
})
export class DashboardRetailerComponent {}
